import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults, onMounted, onBeforeUnmount, computed } from 'vue'

type PropsType = {
  width?: string
  position?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    width: { default: '100' },
    position: { default: 'bottom' }
  },
  emits: ["show", "hide", "click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'show', event: TouchEvent): void
  (e: 'hide', event: TouchEvent): void
  (e: 'click', event: TouchEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { width: string, position: string };





onMounted(() => {
  // SP対応
  document.addEventListener('touchstart', hide)
})

onBeforeUnmount(() => {
  document.removeEventListener('touchstart', hide)
})

const hide = (event: TouchEvent) => {
  emit('hide', event)
}

const toolTipStyle = computed(() => ({
  width: props.width,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tool_tip", __props.position]),
    style: _normalizeStyle(_unref(toolTipStyle)),
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide', $event))),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show', $event))),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 38))
}
}

})